<template>
  <div class="page-container">
    <el-card>
      <!-- 搜索区 -->
      <div class="search-bar">
        <el-input
          v-model="query.keyword"
          placeholder="姓名或手机号"
          clearable
          style="width: 200px"
          @keyup.enter.native="handleSearch"
        />
        <el-select v-model="query.role_type" placeholder="角色类型" clearable style="width: 120px">
          <el-option label="客服" :value="1" />
          <el-option label="管理层" :value="2" />
        </el-select>
        <el-button type="primary" size="mini" icon="el-icon-search" @click="handleSearch">查询</el-button>
        <el-button size="mini" icon="el-icon-refresh" @click="handleReset">重置</el-button>
      </div>

      <!-- 操作按钮 -->
      <div class="action-bar">
        <el-button
          v-permission="['reminder:create']"
          type="success"
          size="mini"
          icon="el-icon-plus"
          @click="handleCreate"
        >新建提醒人</el-button>
      </div>

      <!-- 表格 -->
      <el-table ref="table" :data="tableData" v-loading="loading" border stripe style="width: 100%">
        <el-table-column prop="id" label="ID" width="70" align="center" />
        <el-table-column prop="name" label="姓名" width="100" />
        <el-table-column label="手机号" width="140">
          <template slot-scope="{ row }">{{ maskPhone(row.phone) }}</template>
        </el-table-column>
        <el-table-column label="角色" width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.role_type === 1 ? '' : 'warning'" size="small">
              {{ row.role_type === 1 ? '客服' : '管理层' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="微信关注" width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.openid ? 'success' : 'info'" size="small">
              {{ row.openid ? '已关注' : '未关注' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="接收微信通知" width="120" align="center">
          <template slot-scope="{ row }">
            <el-switch
              v-permission="['reminder:toggleWechatNotify']"
              :value="row.receive_wechat_notify"
              :disabled="toggleLoadingIds.includes(row.id)"
              @change="val => handleToggleNotify(row, val)"
            />
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" min-width="160" />
        <el-table-column label="操作" width="210" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              v-permission="['reminder:followQrcode']"
              type="primary"
              size="mini"
              plain
              icon="el-icon-mobile-phone"
              @click="handleShowQrcode(row)"
            >二维码</el-button>
            <el-button
              v-permission="['reminder:update']"
              size="mini"
              icon="el-icon-edit"
              @click="handleEdit(row)"
            >编辑</el-button>
            <el-button
              v-permission="['reminder:delete']"
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click="handleDelete(row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        :current-page="query.page"
        :page-sizes="[10, 15, 20, 50]"
        :page-size="query.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 16px; text-align: right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>

    <!-- 新建 / 编辑弹窗 -->
    <el-dialog
      :title="dialog.title"
      :visible.sync="dialog.visible"
      width="480px"
      @close="resetForm"
    >
      <el-form ref="reminderForm" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name" placeholder="请输入姓名" />
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入手机号" maxlength="11" />
        </el-form-item>
        <el-form-item label="角色类型" prop="role_type">
          <el-radio-group v-model="form.role_type">
            <el-radio :label="1">客服</el-radio>
            <el-radio :label="2">管理层</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="接收微信通知">
          <el-switch v-model="form.receive_wechat_notify" :active-value="1" :inactive-value="0" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="mini" @click="dialog.visible = false">取消</el-button>
        <el-button type="primary" size="mini" :loading="dialog.loading" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>

    <!-- 关注二维码弹窗 -->
    <el-dialog
      title="关注二维码"
      :visible.sync="qrDialog.visible"
      width="340px"
      :close-on-click-modal="false"
      class="qr-dialog"
      @close="onQrDialogClose"
    >
      <div v-loading="qrDialog.loading" element-loading-text="正在获取二维码…" class="qr-body">
        <template v-if="!qrDialog.loading && qrDialog.qrcodeUrl">
          <img
            ref="qrImg"
            :src="qrDialog.qrcodeUrl"
            class="qr-image"
            crossorigin="anonymous"
            alt="关注二维码"
            @error="onQrImageError"
          />
          <div class="qr-info">
            <p class="qr-name">{{ qrDialog.name }}</p>
            <p class="qr-phone">{{ maskPhone(qrDialog.phone) }}</p>
            <p class="qr-tip">扫码关注"医贝畅"服务号，即可接收订单提醒通知</p>
          </div>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-download"
            :loading="qrDialog.downloading"
            style="margin-top: 16px"
            @click="handleDownloadQrcode"
          >下载二维码</el-button>
        </template>
        <div v-else-if="!qrDialog.loading && !qrDialog.qrcodeUrl" class="qr-empty">
          <i class="el-icon-warning-outline" style="font-size: 40px; color: #e6a23c" />
          <p style="margin: 12px 0 0; color: #909399; font-size: 13px">二维码获取失败，请关闭后重试</p>
        </div>
        <!-- 占位高度，避免 loading 时弹窗高度跳动 -->
        <div v-else style="height: 320px" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getReminderList,
  createReminder,
  updateReminder,
  deleteReminder,
  getReminderFollowQrcode,
  toggleReminderWechatNotify
} from '@/api/reminder'

export default {
  name: 'ReminderManage',

  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      query: { page: 1, pageSize: 15, keyword: '', role_type: '' },

      toggleLoadingIds: [],

      dialog: { visible: false, title: '', loading: false },
      form: { id: null, name: '', phone: '', role_type: 1, receive_wechat_notify: 1 },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        role_type: [{ required: true, message: '请选择角色类型', trigger: 'change' }]
      },

      qrDialog: {
        visible: false,
        loading: false,
        downloading: false,
        qrcodeUrl: '',
        name: '',
        phone: ''
      }
    }
  },

  created() {
    this.fetchData()
  },

  methods: {
    async fetchData() {
      this.loading = true
      try {
        const params = { ...this.query }
        if (!params.keyword) delete params.keyword
        if (params.role_type === '') delete params.role_type
        const res = await getReminderList(params)
        this.tableData = res.data.list
        this.total = res.data.total
        this.$nextTick(() => this.$refs.table && this.$refs.table.doLayout())
      } finally {
        this.loading = false
      }
    },

    maskPhone(phone) {
      if (!phone || phone.length < 7) return phone
      return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
    },

    handleSearch() { this.query.page = 1; this.fetchData() },
    handleReset() { this.query = { page: 1, pageSize: 15, keyword: '', role_type: '' }; this.fetchData() },
    handleSizeChange(val) { this.query.pageSize = val; this.fetchData() },
    handleCurrentChange(val) { this.query.page = val; this.fetchData() },

    handleCreate() {
      this.form = { id: null, name: '', phone: '', role_type: 1, receive_wechat_notify: 1 }
      this.dialog = { visible: true, title: '新建提醒人', loading: false }
    },

    handleEdit(row) {
      this.form = {
        id: row.id,
        name: row.name,
        phone: row.phone,
        role_type: row.role_type,
        receive_wechat_notify: row.receive_wechat_notify ? 1 : 0
      }
      this.dialog = { visible: true, title: '编辑提醒人', loading: false }
    },

    async handleDelete(row) {
      try {
        await this.$confirm(`确认删除提醒人「${row.name}」？此操作不可恢复。`, '提示', { type: 'warning' })
        await deleteReminder({ id: row.id })
        this.$message.success('删除成功')
        this.fetchData()
      } catch (_) { /* 取消操作 */ }
    },

    async handleToggleNotify(row, val) {
      if (this.toggleLoadingIds.includes(row.id)) return
      this.toggleLoadingIds = [...this.toggleLoadingIds, row.id]
      try {
        await toggleReminderWechatNotify({ id: row.id, receive_wechat_notify: val })
        row.receive_wechat_notify = val
        this.$message.success(`已${val ? '开启' : '关闭'}微信通知`)
      } catch (_) {
        // 接口错误已由 request.js 统一提示，此处无需额外处理
      } finally {
        this.toggleLoadingIds = this.toggleLoadingIds.filter(id => id !== row.id)
      }
    },

    handleSubmit() {
      this.$refs.reminderForm.validate(async valid => {
        if (!valid) return
        this.dialog.loading = true
        try {
          if (this.form.id) {
            await updateReminder(this.form)
            this.$message.success('更新成功')
            this.dialog.visible = false
            this.fetchData()
          } else {
            const res = await createReminder(this.form)
            this.$message.success('创建成功')
            this.dialog.visible = false
            this.fetchData()
            // 创建接口直接返回二维码 OSS 地址，无需再调用 follow-qrcode
            const reminder = res.data || {}
            const qrcodeUrl = reminder.qrcode_url || ''
            const name = reminder.name || this.form.name
            const phone = reminder.phone || this.form.phone
            if (qrcodeUrl) {
              this.qrDialog = {
                visible: true,
                loading: false,
                downloading: false,
                qrcodeUrl,
                name,
                phone
              }
            }
          }
        } finally {
          this.dialog.loading = false
        }
      })
    },

    handleShowQrcode(row) {
      this.openQrDialog(row.id, row.name, row.phone)
    },

    async openQrDialog(id, name, phone) {
      this.qrDialog = {
        visible: true,
        loading: true,
        downloading: false,
        qrcodeUrl: '',
        name,
        phone
      }
      try {
        const res = await getReminderFollowQrcode({ id })
        this.qrDialog.qrcodeUrl = res.data.qrcode.url
        // 用接口返回的 reminder 字段更新展示信息（更准确）
        if (res.data.reminder) {
          this.qrDialog.name = res.data.reminder.name
          this.qrDialog.phone = res.data.reminder.phone
        }
      } catch (_) {
        // 接口错误已由 request.js 统一提示
      } finally {
        this.qrDialog.loading = false
      }
    },

    onQrDialogClose() {
      this.qrDialog = {
        visible: false,
        loading: false,
        downloading: false,
        qrcodeUrl: '',
        name: '',
        phone: ''
      }
    },

    onQrImageError() {
      this.$message.warning('二维码图片加载失败，请关闭后重试')
    },

    async handleDownloadQrcode() {
      this.qrDialog.downloading = true
      try {
        await this.doDownloadQrcode()
      } catch (e) {
        console.error('下载二维码失败:', e)
        this.$message.error('下载失败，请右键图片另存为')
      } finally {
        this.qrDialog.downloading = false
      }
    },

    doDownloadQrcode() {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.crossOrigin = 'anonymous'

        img.onload = () => {
          try {
            const QR_SIZE = 280          // 二维码绘制尺寸
            const PD_H = 28             // 左右内边距
            const PD_TOP = 24           // 顶部内边距
            const PD_BTM = 20           // 底部内边距
            const LINE_GAP = 22         // 文字行间距
            const TEXT_TOP_OFFSET = 16  // 二维码底部到第一行文字的距离

            const canvasW = QR_SIZE + PD_H * 2
            const canvasH = PD_TOP + QR_SIZE + TEXT_TOP_OFFSET + LINE_GAP * 2 + 14 + PD_BTM

            // 使用 2× 分辨率，保证下载图片清晰
            const DPR = 2
            const canvas = document.createElement('canvas')
            canvas.width = canvasW * DPR
            canvas.height = canvasH * DPR

            const ctx = canvas.getContext('2d')
            ctx.scale(DPR, DPR)

            // 白色底
            ctx.fillStyle = '#ffffff'
            ctx.fillRect(0, 0, canvasW, canvasH)

            // 二维码图片
            ctx.drawImage(img, PD_H, PD_TOP, QR_SIZE, QR_SIZE)

            // 分隔线
            const lineY = PD_TOP + QR_SIZE + 10
            ctx.strokeStyle = '#eeeeee'
            ctx.lineWidth = 1
            ctx.beginPath()
            ctx.moveTo(PD_H, lineY)
            ctx.lineTo(canvasW - PD_H, lineY)
            ctx.stroke()

            // 姓名
            const textCenterX = canvasW / 2
            let textY = PD_TOP + QR_SIZE + TEXT_TOP_OFFSET + 10
            ctx.fillStyle = '#303133'
            ctx.font = 'bold 15px "PingFang SC", "Microsoft YaHei", sans-serif'
            ctx.textAlign = 'center'
            ctx.fillText(this.qrDialog.name, textCenterX, textY)

            // 手机号（中间四位打码）
            textY += LINE_GAP
            ctx.fillStyle = '#606266'
            ctx.font = '13px "PingFang SC", "Microsoft YaHei", sans-serif'
            ctx.fillText(this.maskPhone(this.qrDialog.phone), textCenterX, textY)

            // 引导文案
            textY += LINE_GAP
            ctx.fillStyle = '#909399'
            ctx.font = '11px "PingFang SC", "Microsoft YaHei", sans-serif'
            ctx.fillText('扫码关注"医贝畅"服务号，即可接收订单提醒通知', textCenterX, textY)

            const dataUrl = canvas.toDataURL('image/png')
            const link = document.createElement('a')
            link.download = `关注二维码_${this.qrDialog.name}.png`
            link.href = dataUrl
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            resolve()
          } catch (e) {
            reject(e)
          }
        }

        img.onerror = () => reject(new Error('图片加载失败'))

        // 追加时间戳强制重新请求（携带 CORS 头），避免使用浏览器缓存的非 CORS 资源
        const sep = this.qrDialog.qrcodeUrl.includes('?') ? '&' : '?'
        img.src = this.qrDialog.qrcodeUrl + sep + '_t=' + Date.now()
      })
    },

    resetForm() {
      this.$refs.reminderForm && this.$refs.reminderForm.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.action-bar {
  margin-bottom: 12px;
}

/* 二维码弹窗主体 */
.qr-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 0 4px;
  min-height: 100px;
}

.qr-image {
  width: 240px;
  height: 240px;
  display: block;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.qr-info {
  margin-top: 14px;
  text-align: center;
  width: 100%;
  border-top: 1px solid #f0f0f0;
  padding-top: 12px;

  .qr-name {
    margin: 0 0 4px;
    font-size: 15px;
    font-weight: 600;
    color: #303133;
  }

  .qr-phone {
    margin: 0 0 6px;
    font-size: 13px;
    color: #606266;
  }

  .qr-tip {
    margin: 0;
    font-size: 11px;
    color: #909399;
    line-height: 1.6;
  }
}
</style>
